const frontendCart = {

    setMask: () => {
        $(".card_number").mask('0000 0000 0000 0000 000', { placeholder: 'XXXX XXXX XXXX XXXX XXX' });
        $(".zipcode ").mask('00000-000', { placeholder: '00000-000' })
    },

    checkCheckboxOnActivePlan: (element) => {
        const radio = element.find('input[type=radio][name=mode]');
        const imgRadio = element.find('.class_checkbox ');

        if (radio.is(':checked')) {
            return false;
        }

        if (radio.val() == 2) {
            $("div.div-amount").show('slow');
            $(".row-coupon").show('slow');
        } else {
            $("div.div-amount").hide('slow');
            $(".row-coupon").hide('slow');
            $(".row-coupon").find('input.coupon').val("");
            $("input[name=amount]").val("1").trigger('keyup');
        }

        $.each($('.class_checkbox'), function (index, value) {
            $(this).removeClass('checked');
        });

        $.each($('.form-checks input[type=radio][name=mode]'), function (index, value) {
            $(this).removeProp('checked');
            $(this).removeAttr('checked');
        });

        imgRadio.addClass('checked');
        radio.prop('checked', 'checked')
        $(".automatic-renovation").hide();
    },

    changePlanIsActive: (element, classCss = 'popular') => {

        $.each($('.card-pricing'), function () {
            $(this).removeClass(classCss);
        });

        $.each($('input[type=radio][name=plan_id]'), function () {
            $(this).removeProp('checked');
        });

        element.addClass(classCss);
        element.find('input[type=radio][name=plan_id]').prop('checked', 'checked');
    },

    changeOtherForms: (element, buyKey = false) => {
        const subscription = element.find('option:selected').data('subscription');
        if (subscription && !buyKey) {
            $('.automatic-renovation').show();
            return;
        }

        $('.automatic-renovation').hide();
    },

    /**
     * Set total price in spans with total-price class
     * @param float total 
     * @param float monthly 
     * @param string currency 
     * @param element JqueryElement 
     * @param boolean discount 
     * @return void
     */
    setTotalPrice: (total, monthly, currency, element = null, discount = false) => {

        if (element != null) {
            const price = monthly > 0 ? monthly : total;
            if(!discount) {
                element.html(`${price.toFixed(2)}`);
            } else {
                element.html(`${currency}${total.toFixed(2)}`);
            }
        }

        if(!discount) {
            $.each($('.total-price'), function (index, value) {
                const span = $(this).find('span');
                span.html(`${currency}${total.toFixed(2)}`);
            });
        }
    },

    setDiscount: (economy, currency, economyLabel = null, element) => {
        if (element.find('li.span-discount').length > 0) {
            element.find('li.span-discount').remove();
        }

        if(economy > 0) {
            element.find('ul').append(`<li class="span-discount">${economyLabel ? economyLabel : 'OFF'} ${currency}${economy.toFixed(2)}!</li>`);
        }
    },

    /**
     * Get the total price of the selected plan
     * @return object
     */
    getTotalPrice: () => {
        const currency = $("select[name=plan_id] option:selected").data('currency');
        const currentTotal = $("select[name=plan_id] option:selected").data('total');
        const economy = $("select[name=plan_id] option:selected").data('economy');
        const amount = $("input[type=radio][name=mode]:checked").val() == 1 ? 1 : $("input[name=amount]").val();
        const label = $("select[name=plan_id] option:selected").data('label-economy');
        const reference = $("select[name=plan_id] option:selected").data('reference');
        const currentMonthly = $("select[name=plan_id] option:selected").data('monthly') ? $("select[name=plan_id] option:selected").data('monthly') : 0;

        return { 'currency': currency, 'total': currentTotal, amount, economy, label, reference, monthly: currentMonthly }
    },

    /**
     * Show form register
     */
    showRegister: () => {
        $('.div-login').fadeOut("fast", function () {
            $('.text-step-2').html($('.text-step-2').data('text-register-step-2'));
            $('.dont-have-account').hide();
            $('.div-register').fadeIn();

            $([document.documentElement, document.body]).animate({
                scrollTop: $(".step-2").offset().top - 50
            }, 1500);
        });
    },

    /**
     * Show form login
     */
    showLogin: () => {
        $('.div-register').fadeOut("fast", function () {
            $('.text-step-2').html($('.text-step-2').data('text-login-step-2'));
            $('.div-login').fadeIn();
            $('.dont-have-account').show();
        });

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".step-2").offset().top - 50
        }, 1500);
    }
}

export default frontendCart;